import React from "react";

// Libraries
import { Col, Container, Row } from "react-bootstrap";
import { m } from "framer-motion";

// Components

import { fadeIn } from "../../../Functions/GlobalAnimations";

const BlogPostLayout04 = (props) => {
  return (
    <div style={props.style}>
      {/* Section Start */}
      <section className="py-[130px]  overflow-hidden lg:py-[90px] sm:py-[50px]  xs:h-auto bg-dark">
        <Container>
          <Row>
            <Col
              lg={6}
              xl={{ offset: 1 }}
              md={6}
              className="flex justify-center flex-col pt-[6.5rem] sm:pt-16 xs:pt-0"
            >
              <div className="inline-block uppercase mb-[25px] text-white leading-[22px]">
                <span className="text-white font-serif">{props.data.date && props.data.date}</span>
                <span className="text-white font-serif">{props.data.published_at && props.data.published_at}</span>
              </div>
              <h3 className="font-serif text-white w-[90%] sm:mb-0 font-medium xs:mb-[25px] lg:w-[95%]">

                {props.data.title && props.data.title}
                {props.data.case && `Decision Summary`}
              </h3>
              <h4 className="font-serif text-white w-[90%] sm:mb-0 font-medium xs:mb-[25px] lg:w-[95%]">

                {props.data.case && `${props.data.case.complainant} vs. ${props.data.case.registrant}`}
              </h4>
            </Col>
            <Col
              md={3}
              className="justify-center flex-col pt-[65px] md:pt-[66px] sm:hidden"
            >
              <span className="h-[1px] opacity-50 bg-white w-full inline-block align-middle mt-[7.4rem] lg:mt-36"></span>
            </Col>

          </Row>
        </Container>
      </section>
      {/* Section End */}

      {/* Section Start */}

      {props.data.content && <section className="py-[120px] overflow-hidden lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]" data-test='news-item-content'>
        <Container>
          <m.div className="row" {...fadeIn}>
            <Col lg={{ span: 9, offset: 1 }} className="">
              <div
              className="ql-editor"
              style={{"lineHeight": "2"}}
                dangerouslySetInnerHTML={{
                  __html: props.data.content
                    .replace(/^b'/, "")
                    .replace(/'$/, ""),
                }}
              ></div>
            </Col>
          </m.div>
        </Container>
      </section>}
      {/* Section End */}

    </div>
  );
};

export default BlogPostLayout04;
